
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M499.997 118.348c210.785 0 381.654 170.868 381.654 381.652S710.782 881.652 499.997 881.652c-210.779 0-381.648-170.868-381.648-381.652s170.869-381.652 381.648-381.652m0-118.348C224.295 0 0 224.294 0 500s224.295 500 499.997 500S1000 775.706 1000 500 775.698 0 499.997 0z","fill":"#4d3d36"}}),_c('path',{attrs:{"d":"M675.307 499.907H324.601a32.737 32.737 0 013.554-15.017l141.482-282.975a33.81 33.81 0 0160.635 0L671.76 484.89a32.813 32.813 0 013.547 15.017z","fill":"#ff6b62"}}),_c('path',{attrs:{"d":"M675.307 499.907a33.166 33.166 0 01-3.547 15.297l-141.488 282.96c-12.564 24.86-48.072 24.86-60.635 0l-141.482-282.96a33.09 33.09 0 01-3.554-15.297z","fill":"#4d3d36"}})])
          )
        }
      }
    